import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
  marginLeft?: number | string;
}

const BinTrash: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit', marginLeft }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{
        fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`,
        color,
        marginLeft,
      }}
      viewBox="0 0 20 20"
    >
      <g
        id="Rectangle_1418"
        data-name="Rectangle 1418"
        fill="#fff"
        stroke="#707070"
        strokeWidth="1"
        opacity="0"
      >
        <rect width="20" height="20" stroke="none" />
        <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
      </g>
      <g id="Group_6721" data-name="Group 6721" transform="translate(2.166 1.074)">
        <g id="trash-2">
          <path
            id="Path_4653"
            data-name="Path 4653"
            d="M3,6H19.1"
            transform="translate(-3 -2.422)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Path_4654"
            data-name="Path 4654"
            d="M17.522,5.578V18.1a1.789,1.789,0,0,1-1.789,1.789H6.789A1.789,1.789,0,0,1,5,18.1V5.578m2.683,0V3.789A1.789,1.789,0,0,1,9.472,2H13.05a1.789,1.789,0,0,1,1.789,1.789V5.578"
            transform="translate(-3.211 -2)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <line
            id="Line_309"
            data-name="Line 309"
            y2="5.367"
            transform="translate(6.362 8.05)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <line
            id="Line_310"
            data-name="Line 310"
            y2="5.367"
            transform="translate(9.939 8.05)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default BinTrash;
